import React, { FunctionComponent } from 'react'
import { ImageSourcePropType } from 'react-native'

import styled from 'styled-components/native'

import liveChatIllustrationIconImage from '../../assets/live_chat_illustration_icon.png'
import { tID } from '../../utils'
import { Image } from '../image/Image'

const ImageContainer = styled(Image)<{ size: string }>(({ size }) => ({
  width: size,
  height: size,
}))

/**
 * Illustration to show on the treatment card
 */
export const LiveChatIllustrationIcon: FunctionComponent<LiveChatIllustrationIconProps> = ({ size = 48 }) => {
  const sizeInPixels = `${size}px`
  return (
    <ImageContainer
      size={sizeInPixels}
      testID={`${tID('LiveChatIllustrationIcon')}`}
      source={liveChatIllustrationIconImage as ImageSourcePropType}
    />
  )
}

type LiveChatIllustrationIconProps = {
  size?: number
}
